import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Breadcrumb } from '../../interfaces';

@Component({
  selector: 'phoenix-breadcrumbs',
  template: ` <div class="flex items-center">
    @for (crumb of breadcrumbs; track crumb; let index = $index) {
      <ng-container>
        @if (breadcrumbs.length > 1 && index !== 0 && !crumb.block) {
          <em class="material-icons"> navigate_next </em>
        }
        @if (!crumb.block) {
          <span
            [ngClass]="
              !crumb.selected
                ? 'text-blue-700 cursor-pointer hover:underline'
                : ''
            "
            (click)="changeOnCrumb(crumb, index)"
            (keyup)="(null)"
            >{{ crumb.label }}</span
          >
        }
      </ng-container>
    }
  </div>`,
  styles: [],
  standalone: false,
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs: Breadcrumb[] = [];
  @Input() preserveState = false;
  @Output() crumbChange = new EventEmitter();

  changeOnCrumb(crumb: Breadcrumb, index: number) {
    if (!crumb.selected) {
      if (!this.preserveState) {
        this.breadcrumbs = this.breadcrumbs.map(data => ({
          ...data,
          selected: false,
        }));

        this.breadcrumbs[index].selected = true;
      }
      this.crumbChange.emit(crumb);
    }
  }
}
